import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import Nav from '../AppLayout/Navigation'
import { Link } from 'react-router-dom'
import { TwitterButton } from "react-social";
import './styles.css'

export default class Layout extends Component {

    onFacebookClick() {
        var path = 'https://snowflakeapi.datausa.com/facebooklink?path=' + window.location.pathname
        console.log(path)
        window.FB.ui({
            method: 'share',
            href: path,

        }, function (response) { });
    }

    render() {

        let path = this.props.location.pathname.split('/')[1];
        let sharePath = window.location.href

        return (
            <div className={'holiday-card ' + path}>
                <header className='site-header' role='banner'>
                    <h1 className='title'><Link to={'/'} >Create -A- Flake</Link></h1>
                    <h2 className='sub-title'>From your friends at <a href={'https://holiday.datausa.com'} target={'_blank'} rel="noopener noreferrer">DATA</a></h2>
                </header>
                 <main>
                     <Nav />
                    {this.props.children}
                </main>
                <footer className='colophon' role='contentinfo'>
                    <div className='share'>
                        <button
                            onClick={this.onFacebookClick.bind(this)}>
                            <FontAwesome name="facebook-official" />
                        </ button>
                        <TwitterButton url={sharePath}>
                            <FontAwesome name="twitter" />
                        </TwitterButton>
                    </div>
                </footer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AppLayout/layout.js